// extracted by mini-css-extract-plugin
export default {"rail":"components-Shared-Rail-style__rail--OnKAv","right":"components-Shared-Rail-style__right--_s6sH","left":"components-Shared-Rail-style__left--pZU_z"};